/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserUserEmailListResponse } from './RevisdomAPIViewModelsUserUserEmailListResponse';
import {
    RevisdomAPIViewModelsUserUserEmailListResponseFromJSON,
    RevisdomAPIViewModelsUserUserEmailListResponseFromJSONTyped,
    RevisdomAPIViewModelsUserUserEmailListResponseToJSON,
    RevisdomAPIViewModelsUserUserEmailListResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserUserEmailListResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1UserEmailListResponse
 */
export interface ApiResponse1UserEmailListResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1UserEmailListResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1UserEmailListResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsUserUserEmailListResponse}
     * @memberof ApiResponse1UserEmailListResponse
     */
    data?: RevisdomAPIViewModelsUserUserEmailListResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1UserEmailListResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1UserEmailListResponse interface.
 */
export function instanceOfApiResponse1UserEmailListResponse(value: object): value is ApiResponse1UserEmailListResponse {
    return true;
}

export function ApiResponse1UserEmailListResponseFromJSON(json: any): ApiResponse1UserEmailListResponse {
    return ApiResponse1UserEmailListResponseFromJSONTyped(json, false);
}

export function ApiResponse1UserEmailListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1UserEmailListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsUserUserEmailListResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1UserEmailListResponseToJSON(json: any): ApiResponse1UserEmailListResponse {
    return ApiResponse1UserEmailListResponseToJSONTyped(json, false);
}

export function ApiResponse1UserEmailListResponseToJSONTyped(value?: ApiResponse1UserEmailListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsUserUserEmailListResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

